import { Order } from "@/types";
import { useGetDeviationsByOrderId } from "@/services/Orders";
import NewDeviation from "./NewDeviation/NewDeviation";
import ViewDeviation from "./ViewDeviation/ViewDeviation";

interface DeviationsTabContentProps {
  order: Order;
}

const DeviationsTabContent = ({ order }: DeviationsTabContentProps) => {
  const { data: orderDeviations } = useGetDeviationsByOrderId(order.id);

  return (
    <>
      <NewDeviation order={order} />
      {orderDeviations && orderDeviations.length > 0 && <ViewDeviation deviations={orderDeviations} />}
    </>
  );
};

export default DeviationsTabContent;
